/// <reference path="../../../Modules/Attr/Grid/NoboxEntityGrid.ts" />
namespace Nobox.CRM {

    @Serenity.Decorators.registerClass()
    export class ProductdealsGrid extends NoboxEntityGrid<ProductdealsRow, any> {
        protected getColumnsKey() { return ProductdealsColumns.columnsKey; }
        protected getDialogType() { return ProductdealsDialog; }
        protected getIdProperty() { return ProductdealsRow.idProperty; }
        protected getInsertPermission() { return ProductdealsRow.insertPermission; }
        protected getLocalTextPrefix() { return ProductdealsRow.localTextPrefix; }
        protected getService() { return ProductdealsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}